<template>
  <div class="header" :class="[themeColor]">
    <div class="logo">
      <a href="/">
        <img class="image" src="../assets/images/logo.png" alt="" />
      </a>
      <h2>湖北省残疾人求职招聘信息平台</h2>
    </div>
    <ul class="navbar">
      <router-link to="/" exact v-slot="{ href, navigate, isActive }">
        <li class="navbar-item" :class="{ active: isActive }">
          <a :href="href" @click="navigate">首页</a>
        </li>
      </router-link>
      <router-link exact to="/jobs" v-slot="{ href, navigate, isActive }">
        <li class="navbar-item" :class="{ active: isActive }">
          <a :href="href" @click="navigate">求职招聘</a>
        </li>
      </router-link>
      <router-link to="/events" v-slot="{ href, navigate, isActive }">
        <li class="navbar-item" :class="{ active: isActive }">
          <a :href="href" @click="navigate">活动专区</a>
        </li>
      </router-link>
      <router-link
        exact
        :to="{
          path: '/announcement',
          query: { announcementId: announcementId },
        }"
        v-slot="{ href, navigate, isActive }"
      >
        <li class="navbar-item" :class="{ active: isActive }">
          <a :href="href" @click="navigate">新闻资讯</a>
          <ul
            class="p_level2Box"
            style="
              height: 130px;
              padding-top: 15px;
              margin-top: 0px;
              padding-bottom: 15px;
              margin-bottom: 0px;
            "
          >
            <li class="p_level2Item">
              <p class="p_menu2Item js_editor_click">
                <router-link
                  :to="{
                    path: '/announcement',
                    query: { announcementId: '1' },
                  }"
                >
                  <span>新闻动态</span>
                </router-link>
              </p>
            </li>
            <li class="p_level2Item">
              <p class="p_menu2Item js_editor_click">
                <router-link
                  :to="{
                    path: '/announcement',
                    query: { announcementId: '2' },
                  }"
                >
                  <span>政策法规</span>
                </router-link>
              </p>
            </li>
            <li class="p_level2Item">
              <p class="p_menu2Item js_editor_click">
                <router-link
                  :to="{
                    path: '/announcement',
                    query: { announcementId: '3' },
                  }"
                >
                  <span>通知公告</span>
                </router-link>
              </p>
            </li>
          </ul>
        </li>
      </router-link>
    </ul>
    <span>|</span>
    <div class="user">
      <div class="user-dh">
        <router-link to="/solid" class="back" v-if="isLogin">
          <img src="../assets/images/solid.png" alt="" />消息
          <p class="sum" v-if="messageCount">{{ messageCount }}</p>
        </router-link>
        <router-link to="/enterpriseApplication" class="back" v-if="isLogin">
          <img src="../assets/images/agency.png" alt="" />待办事项
          <p class="sum" v-if="agencyCount">{{ agencyCount }}</p>
        </router-link>
        <a
          title="网站信息无障碍工具条"
          href="javascript:;"
          class="easyWzaBtn back"
        >
          <img src="../assets/images/cjr.png" alt="" />无障碍浏览</a
        >
      </div>
      <div class="login" v-if="!isLogin">
        <div class="login-Register">注册/登录</div>
        <div class="service-cards">
          <div class="cards">
            <div class="card">
              <router-link to="/user" class="card-go">
                <div class="icon-container">
                  <svg
                    t="1754897113599"
                    class="icon"
                    viewBox="0 0 1024 1024"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    p-id="99438"
                    width="64"
                    height="64"
                  >
                    <path
                      d="M625.38752 525.43488c4.47232 12.06016 6.3872 25.39264 6.3872 38.08768 0 32.37376-12.13696 62.21056-35.13344 84.4288-22.99648 22.85312-53.66016 34.91328-84.96128 34.91328-66.43456 0-120.73216-53.95712-120.73216-119.97696 0-12.69504 1.91488-26.02752 6.3872-38.08768H0v369.45152C0 948.84352 44.71552 993.28 99.65312 993.28h824.69376c54.9376 0 99.65312-44.43648 99.65312-99.02848V524.8H625.38752v0.63488z"
                      fill="#4caf50"
                      p-id="99439"
                    ></path>
                    <path
                      d="M456.7424 525.66528l-7.02464 13.41184a67.4816 67.4816 0 0 0-5.11232 25.54624c0 37.68064 30.02368 67.69664 67.71456 67.69664 37.68832 0 67.712-30.016 67.712-67.69664 0-8.94208-1.27744-17.24416-5.10976-25.54624l-6.3872-13.41184h-111.79264zM1024 284.25728c0-54.92224-44.71552-99.62752-99.65312-99.62752h-212.72064V146.30912c0-65.14176-53.66016-118.14912-118.17984-118.14912h-161.61536c-65.15968 0-118.17984 53.64736-118.17984 118.14912v38.32064H99.65312C44.71552 184.6272 0 229.33504 0 284.25728v188.40064h1023.36v-188.40064h0.64zM387.11296 146.94912c0-24.2688 20.4416-44.70528 44.71808-44.70528h161.61536c24.27648 0 44.71808 20.43648 44.71808 44.70528V185.2672h-251.05152V146.94912z"
                      fill="#4caf50"
                      p-id="99440"
                    ></path>
                  </svg>
                </div>
                <button class="btn green-btn">我要求职</button>
              </router-link>
            </div>

            <!-- 我要招聘 -->
            <div class="card">
              <a
                href="https://clxt.hbcjrjy.cn/"
                target="_blank"
                class="card-go"
              >
                <div class="icon-container">
                  <svg
                    t="1754897311187"
                    class="icon"
                    viewBox="0 0 1143 1024"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    p-id="105533"
                    width="64"
                    height="64"
                  >
                    <path
                      d="M1106.895525 948.506631h-71.412615V452.736457a98.573212 98.573212 0 0 0-64.271353-93.383896l-282.079827-89.789461a50.15546 50.15546 0 0 0-32.135677 3.594435 44.394842 44.394842 0 0 0-14.282522 28.731675v646.4984h-35.706308V86.389744A83.624172 83.624172 0 0 0 574.871547 18.143089a109.689776 109.689776 0 0 0-89.265768-14.282523L182.102167 90.055592A104.381438 104.381438 0 0 0 107.118922 190.628357v761.448904h-71.412615a35.920545 35.920545 0 0 0 0 71.817286h1071.189218a33.825775 33.825775 0 0 0 35.706307-35.920545 36.825105 36.825105 0 0 0-35.706307-39.467371z m-303.503612-323.261102h71.412615a35.920545 35.920545 0 0 1 0 71.84109h-71.412615a35.920545 35.920545 0 0 1 0-71.84109zM285.650458 337.928777h142.825229a35.920545 35.920545 0 0 1 0 71.817286h-142.825229a35.920545 35.920545 0 0 1 0-71.817286z m0 287.316752h142.825229a35.920545 35.920545 0 0 1 0 71.84109h-142.825229a35.920545 35.920545 0 0 1 0-71.84109z"
                      fill="#2196f3"
                      p-id="105534"
                    ></path>
                  </svg>
                </div>
                <button class="btn blue-btn">我要招聘</button>
              </a>
            </div>

            <!-- 机构登录 -->
            <div class="card">
              <a
                href="https://clxt.hbcjrjy.cn/"
                target="_blank"
                class="card-go"
              >
                <div class="icon-container">
                  <svg
                    t="1754897387299"
                    class="icon"
                    viewBox="0 0 1046 1024"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    p-id="109355"
                    width="64"
                    height="64"
                  >
                    <path
                      d="M485.051429 0h50.491428c14.034286 1.211429 27.542857 7.92 36.628572 18.754286 9.291429 10.822857 13.542857 25.451429 12.971428 39.577143 0.011429 306.651429-0.011429 613.302857 0 919.954285h54.857143V298.285714c-0.102857-28.548571 0.217143-57.108571-0.205714-85.645714 0.72-16.902857 10.16-33.108571 24.514285-42.045714 10.948571-7.28 24.56-9.291429 37.462858-8.297143 10.011429 0.422857 19.92 3.645714 28.114285 9.451428 5.234286 3.474286 9.371429 8.251429 13.828572 12.617143 70.868571 70.857143 141.725714 141.737143 212.594285 212.582857 8.091429 9.348571 12.788571 21.6 12.834286 33.977143 0.011429 182.445714-0.011429 364.902857 0.011429 547.36 17.92 0.022857 35.84-0.034286 53.771428 0.011429 8.811429-0.148571 17.348571 5.337143 20.914286 13.394286 3.862857 8.182857 2.137143 18.582857-4.16 25.085714-3.6 4.011429-8.731429 6.24-13.942857 7.222857H20.937143C10.114286 1023.12 0.937143 1013.942857 0 1003.131429v-3.908572c0.902857-11.028571 10.537143-20.605714 21.68-20.857143 17.154286-0.194286 34.308571-0.022857 51.462857-0.08 0.022857-188.948571-0.022857-377.908571 0.011429-566.834285 1.097143-13.657143 7.954286-26.48 18.125714-35.542858C211.325714 255.931429 331.314286 135.885714 451.348571 15.874286 460.32 6.857143 472.411429 1.28 485.051429 0M271.12 306.697143c-11.314286 0.754286-20.891429 11.12-20.742857 22.48-0.034286 36.582857-0.057143 73.177143 0.011428 109.76 0.034286 9.531429 6.8 18.48 15.874286 21.268571 4.068571 1.371429 8.4 1.028571 12.628572 1.051429 69.36-0.011429 138.731429 0.011429 208.102857-0.011429 9.428571 0.045714 18.32-6.525714 21.245714-15.462857 1.485714-4.034286 1.2-8.377143 1.211429-12.594286-0.022857-34.708571 0.022857-69.405714-0.022858-104.114285 0.171429-11.988571-10.605714-22.685714-22.594285-22.468572-71.897143 0.034286-143.805714-0.137143-215.714286 0.091429m475.702857 77.977143c-9.222857 2.32-15.931429 11.542857-15.394286 21.028571 0.022857 164.594286-0.022857 329.188571 0.011429 493.771429-0.045714 7.325714 4.125714 14.445714 10.525714 18 5.462857 3.2 12.125714 3.131429 18.217143 2.342857 9.554286-1.588571 17.097143-10.64 16.948572-20.331429 0.034286-164.605714 0-329.211429 0.011428-493.817143 0.285714-7.097143-3.222857-14.24-9.177143-18.148571-6.114286-4.228571-14.125714-4.228571-21.142857-2.845714m100.617143 128.034285c-6.468571 1.68-11.942857 6.697143-14.182857 12.994286-1.565714 4.022857-1.245714 8.422857-1.257143 12.651429 0.011429 120.377143-0.022857 240.754286 0.011429 361.131428-0.045714 7.325714 4.16 14.457143 10.571428 18 5.417143 3.222857 12.022857 2.982857 18.08 2.342857 9.565714-1.565714 17.165714-10.594286 17.028572-20.297142 0.057143-121.931429 0-243.862857 0.034285-365.794286 0.285714-7.085714-3.211429-14.194286-9.131428-18.137143-6.114286-4.262857-14.114286-4.228571-21.154286-2.891429m-648.091429 25.062858c-10.56 1.657143-19.028571 11.554286-18.891428 22.274285-0.022857 36.571429-0.045714 73.142857 0.011428 109.725715 0 9.371429 6.537143 18.182857 15.405715 21.142857 4.228571 1.531429 8.788571 1.177143 13.211428 1.2 92.582857-0.011429 185.165714 0.011429 277.76-0.011429 9.474286 0.114286 18.445714-6.468571 21.382857-15.44 1.497143-4.045714 1.2-8.411429 1.222858-12.628571-0.022857-34.674286 0.022857-69.337143-0.022858-104 0.217143-12.011429-10.537143-22.788571-22.548571-22.571429-80.788571-0.034286-161.577143-0.011429-242.365714-0.011428-15.051429 0.205714-30.137143-0.422857-45.165715 0.32m0.902858 228.434285c-10.96 1.245714-19.965714 11.405714-19.794286 22.445715-0.022857 36.548571-0.045714 73.085714 0.011428 109.634285-0.137143 12.125714 10.902857 22.857143 23.017143 22.4 94.48 0 188.96 0.011429 283.44-0.011428 11.908571 0.194286 22.571429-10.411429 22.491429-22.297143 0.045714-36.617143 0.034286-73.234286 0.011428-109.851429 0.057143-9.497143-6.594286-18.48-15.611428-21.36-3.325714-1.188571-6.88-1.2-10.354286-1.165714-94.4 0.16-188.822857-0.24-283.211428 0.205714z"
                      p-id="109356"
                      fill="#ff9800"
                    ></path>
                  </svg>
                </div>
                <button class="btn orange-btn">机构登录</button>
              </a>
            </div>
          </div>
        </div>
      </div>

      <div class="dropdown-menu" v-else>
        <span class="dropdown-menu__email">
          {{ userName || phoneNumber }}
          <i class="arrow"></i>
        </span>
        <ul class="dropdown-menu__wrapper">
          <router-link to="/resume">
            <li class="dropdown-menu__item">我的简历</li>
          </router-link>
          <router-link to="/jobSearchProgress">
            <li class="dropdown-menu__item">求职进展</li>
          </router-link>
          <router-link to="/positionSubscription">
            <li class="dropdown-menu__item">岗位订阅</li>
          </router-link>
          <router-link to="/follow">
            <li class="dropdown-menu__item">关注企业/收藏岗位</li>
          </router-link>
          <li class="dropdown-menu__item" @click="handleLogout">退出登录</li>
        </ul>
      </div>
    </div>
    <div class="feedback">
      <router-link to="/feedback" class="back">
        <img src="../assets/images/index20231114_3.png" alt="" />
      </router-link>
    </div>
  </div>
</template>
<script>
import {
  getSysMessageCount,
  getCheckResumeApplicationUnHandleCount,
} from "@/api/index";
import { mapGetters } from "vuex";
import { getToken } from "@/helper/auth";
export default {
  name: "Header",
  data: () => ({
    messageCount: "",
    agencyCount: "",
  }),
  props: {
    themeColor: {
      type: String,
      default: "main-color",
    },
  },
  computed: {
    ...mapGetters([
      "isLogin",
      "phoneNumber",
      "userName",
      "profilePhoto",
      "announcementId",
    ]),
  },
  watch: {
    isLogin(newVal) {
      if (newVal && getToken()) {
        getSysMessageCount().then((res) => {
          this.messageCount = res.data;
        });
        getCheckResumeApplicationUnHandleCount().then((res) => {
          this.agencyCount = res.data;
        });
      }
    },
  },
  created() {
    this.fetchMessageCount();
  },
  methods: {
    fetchMessageCount() {
      if (getToken()) {
        getSysMessageCount().then((res) => {
          this.messageCount = res.data;
        });
        getCheckResumeApplicationUnHandleCount().then((res) => {
          this.agencyCount = res.data;
        });
      }
    },
    handleLogout() {
      this.$store.dispatch("FedLogOut").then(() => {
        location.href = "/home";
      });
    },
  },
};
</script>
<style lang="less" scoped>
@font-face {
  font-family: "DingTalk-JinBuTi";
  // src: url(../assets/fonts/DingTalk-JinBuTi.woff2) format("woff2");
  font-weight: 400;
  font-style: normal;
}

.header {
  min-width: @main-width;
  width: 100%;
  padding: 0 5%;
  margin: auto;
  color: #333;
  font-family: "DingTalk-JinBuTi";
  display: flex;
  height: 80px;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
  position: fixed;
  background: #fff;
  box-shadow: 0px 5px 10px 0px #c2c1c180;
  z-index: 999;
  &.main-color {
    background-color: #fff;
    .navbar-item {
      &:hover {
        color: @main-color;
      }
      &:hover > ul {
        display: block;
      }
    }

    .navbar-item:hover::before {
      color: #00a0e9;
      opacity: 1;
      bottom: 0px;
    }
    .login-text {
      color: @main-color;
    }
  }
  &.is-transparent {
    color: #333;
    .navbar-item {
      &:hover {
        color: @main-color;
      }
      &:hover > ul {
        display: block;
      }
    }
    .navbar-item:hover::before {
      color: #00a0e9;
      opacity: 1;
      bottom: 0px;
    }
    .active {
      color: @main-color;
    }
  }
}

.logo {
  display: flex;
  justify-content: center;
  align-items: center;
  a {
    height: 100%;
    display: block;
    img {
      width: 80px;
      height: auto;
    }
  }
}

.navbar {
  margin-left: auto;
  margin-right: 20px;
  font-size: 1vw;
  display: flex;
  &-item {
    padding: 28px 0px;
    margin: 0 15px;
    position: relative;
    &.active {
      color: @main-color;
    }
    .p_level2Box {
      display: none;
      height: auto;
      padding: 15px 0;
      background: #00a0e9;
      width: 130px;
      position: absolute;
      left: 50%;
      top: 100%;
      z-index: 1100;
      transform: translateX(-50%);
      border-bottom-left-radius: 5px;
      border-bottom-right-radius: 5px;
      .p_level2Item {
        position: relative;
        width: 100%;
        a {
          font-size: 15px;
          padding: 0 10px;
          line-height: 35px;
          display: block;
          text-align: center;
          color: #666;
          opacity: 1;
          transition: all ease 0.3s;
        }
        a {
          color: rgba(255, 255, 255, 0.8);
        }

        a:hover {
          color: #fff;
        }
      }
    }
  }
  &-item::before {
    content: "";
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: 0px;
    border: 8px solid;
    border-color: transparent transparent #00a0e9 transparent;
    opacity: 0;
    // transition: all 0.5s ease;
  }
}
.user {
  margin-left: 40px;
  position: relative;
  font-size: 1vw;
  display: flex;
  justify-content: center;
  align-items: center;
  .user-dh {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 40px;
    .back {
      display: inline-block;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 5px 10px;
      position: relative;
      img {
        width: 20px;
        height: 20px;
        margin-right: 5px;
      }
      .sum {
        box-sizing: border-box;
        padding: 0 5px;
        min-width: 20px;
        height: 20px;
        border-radius: 20px;
        background-color: #2174ff;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #fff;
        font-size: 12px;
        font-weight: 600;
        line-height: 20px;
        position: absolute;
        left: 20px;
        top: -10px;
        z-index: 1;
      }
    }
    .back:hover {
      color: #00a0e9;
      opacity: 1;
    }
  }
  .login {
    position: relative;
    padding: 23px 0;
    .login-Register {
      border: 1px solid #000;
      padding: 5px 20px;
      border-radius: 20px;
    }
    .login-Register:hover {
      border: 1px solid #00a0e9;
      color: #00a0e9;
    }

    .service-cards {
      display: none;
      position: absolute;
      right: 0;
      top: 70px;
      background: #fff;
      box-shadow: 0px 10px 20px 0px #8a808080;
      border-radius: 5px;
      .cards {
        display: flex;
        justify-content: center;
        align-items: center;
        .card {
          width: 180px;
          text-align: center;
          transition: transform 0.3s ease;
          padding: 20px 0;
          .card-go {
            padding: 0 20px;
            display: flex;
            flex-direction: column;
            align-items: center;
            border-right: 1px solid #f3eeee;
            .icon-container {
              width: 50px;
              height: 50px;
              display: flex;
              align-items: center;
              justify-content: center;
              position: relative;
              overflow: hidden;
            }
            .btn {
              padding: 8px 15px;
              border: none;
              border-radius: 30px;
              font-size: 16px;
              font-weight: 500;
              cursor: pointer;
              transition: all 0.3s ease;
              margin-top: 10px;
            }
            .green {
              background-color: #4caf50;
            }

            .blue {
              background-color: #2196f3;
            }

            .orange {
              background-color: #ff9800;
            }

            .green-btn {
              background-color: rgba(76, 175, 80, 0.1);
              color: #4caf50;
            }

            .blue-btn {
              background-color: rgba(33, 150, 243, 0.1);
              color: #2196f3;
            }

            .orange-btn {
              background-color: rgba(255, 152, 0, 0.1);
              color: #ff9800;
            }

            .btn:hover {
              opacity: 0.9;
              transform: scale(1.05);
              box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
            }
          }
        }
        .card:nth-child(3) .card-go {
          border-right: none;
        }
        .card:hover {
          transform: translateY(-5px);
        }
      }
    }

    .service-cards::before {
      content: "";
      position: absolute;
      left: 90%;
      transform: translateX(-50%);
      top: -15px;
      border: 8px solid;
      border-color: transparent transparent #fff transparent;
    }
  }
  .login:hover {
    .service-cards {
      display: block;
    }
  }
  .arrow {
    display: inline-block;
    border: 1px solid;
    border-width: 1px 1px 0 0;
    transform: rotate(135deg);
    transform-origin: center;
    vertical-align: 5px;
    margin-left: 5px;
    transition: all 0.3s;
    width: 10px;
    height: 10px;
  }
  .dropdown-menu {
    position: relative;
    z-index: 1000;
    padding: 25px 20px;
    &__email {
      line-height: 2;
      cursor: pointer;
    }
    &__wrapper {
      position: absolute;
      display: none;
      right: 0;
      color: @regular-text-color;
      padding: 9px 0;
      width: 200px;
      border-radius: 5px;
      box-shadow: 0px 10px 20px 0px #8a808080;
      background: #fff;
      top: 70px;
    }
    &__wrapper::before {
      content: "";
      position: absolute;
      left: 70%;
      transform: translateX(-50%);
      top: -15px;
      border: 8px solid;
      border-color: transparent transparent #fff transparent;
    }
    &__item {
      padding: 9px 12px;
      cursor: pointer;
      font-size: 16px;
      &:hover {
        background: #efefef58;
      }
    }
  }
  .dropdown-menu:hover {
    .arrow {
      transform: rotate(-45deg);
      vertical-align: -3px;
    }
    .dropdown-menu__wrapper {
      display: block;
    }
  }
}
.feedback {
  margin-left: 40px;
  .back {
    margin: 5px;
    img {
      width: 25px;
    }
  }
}

@media (max-width: 1680px) {
  .header {
    padding: 0;
  }
  .navbar {
    font-size: 16px;
  }
  .user {
    font-size: 16px;
  }
}

@media (max-width: 1560px) {
  .header {
    padding: 0;
  }
  .navbar {
    font-size: 16px;
  }
  .user {
    font-size: 16px;
  }
}

@media (max-width: 1400px) {
  .header {
    padding: 0;
  }
  .logo h2 {
    font-size: 20px;
  }
  .navbar {
    font-size: 15px;
  }
  .user {
    font-size: 15px;
  }
}

@media (max-width: 1300px) {
  .header {
    padding: 0;
  }
  .logo h2 {
    font-size: 16px;
  }
  .navbar {
    font-size: 14px;
  }
  .user {
    font-size: 14px;
  }
}
</style>
